import AppointmentWhen from './AppointmentWhen'

export default AppointmentWhen